import React, {Component} from "react"
import styled from "styled-components"

import Slider from "@irati/ui/src/Slider"
import id from "@irati/utils/id"
import {minWidthMedia, PHONE, PHONE_LANDSCAPE, TABLET} from "@irati/ui/src/global/media"
import TrophyImg from "@irati/ui/src/Trophy"

import {TrophyButton} from "./styled"
import {Item, Trophy} from "./types"
import {CustomTrophy} from "./"

interface WrapperProps {
  sliderWidth: string
  show: boolean
}

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  .slick-slider {
    height: 120px;
    display: flex;
  }
  .slick-slide {
    width: 120px !important; /* required to override width styling from react-slick */
  }
  ${minWidthMedia.tablet`
    width: ${(props: WrapperProps) => props.sliderWidth};
  `}
  ${(props: WrapperProps) => !props.show && "display: none;"}
`

const MobileResponsiveWidth = styled.div`
  max-width: 240px;
  margin: auto;
  ${minWidthMedia.phone`
    max-width: 100%;
  `}
`

interface Props {
  item: Item
  onChange(trophy: Trophy): void
  show: boolean
  sliderWidth: string
  trophies: Trophy[]
  updateError(errorMsg: string): void
}

interface State {
  selected?: Trophy
  settings: any
  isCustom: boolean
}

class InlineTrophies extends Component<Props, State> {
  static defaultProps = {
    id: "selectTrophy"
  }

  state = {
    selected: this.props.item.trophy,
    settings: {
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
        {breakpoint: PHONE - 1, settings: {slidesToShow: 2, slidesToScroll: 2}},
        {breakpoint: PHONE_LANDSCAPE, settings: {slidesToShow: 3, slidesToScroll: 3}},
        {breakpoint: TABLET, settings: {slidesToShow: 4, slidesToScroll: 4}}
      ]
    },
    isCustom: false
  }

  componentDidMount() {
    const {settings} = this.state
    const {item, trophies} = this.props
    if (item.trophy) {
      const index = trophies.findIndex((trophy) => this.isSelected(trophy, item))
      const slideToGoTo = Math.floor(index / this.slider.getSlidesToShow(settings)) * this.slider.getSlidesToShow(settings)
      this.slider.slickSlider.current.slickGoTo(slideToGoTo)
    }
  }

  handleSave = (selected: Trophy) => {
    this.setState({selected, isCustom: false})
    const {onChange} = this.props
    // remove id prop from trophy
    const {id: _, ...trophy} = selected
    onChange(trophy)
  }

  handleCustomImage = (href: string) => {
    const {onChange} = this.props
    const image = {
      alt: "custom-image-uploaded",
      href
    }
    this.setState({selected: image, isCustom: true})
    onChange(image)
  }

  isSelected = (trophy: Trophy, item: Item) => {
    const {selected} = this.state
    if (!selected && !item.trophy) {
      return false
    }
    return selected.href === trophy.href || trophy.href === item.href
  }

  render() {
    const {trophies, show, item, sliderWidth, updateError} = this.props
    const {settings, isCustom} = this.state
    return (
      <Wrapper show={show} sliderWidth={sliderWidth}>
        <MobileResponsiveWidth>
          <Slider
            settings={settings}
            ref={(c: any) => {
              this.slider = c
            }}>
            <CustomTrophy
              setError={updateError}
              selected={isCustom}
              onUpload={(uploaded: string) => this.handleCustomImage(uploaded)}
              trophy={undefined}
            />
            {trophies.map((trophy, i: number) => (
              <TrophyButton
                key={trophy.id}
                id={id(`button${i}`, this.props)}
                selected={this.isSelected(trophy, item)}
                onClick={() => this.handleSave(trophy)}>
                <TrophyImg src={trophy.href} />
              </TrophyButton>
            ))}
          </Slider>
        </MobileResponsiveWidth>
      </Wrapper>
    )
  }
}

export default InlineTrophies
